import { useEffect, useState } from "react";
import { Button, createTheme, ThemeProvider } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { mediaQuery, useMediaQuery } from "../components/useMediaquery";
import styles from "./Home.module.css";
import CommonHeader from "../components/CommonHeader";
import BaseDialog from "../components/BaseDialog";
import axios from "axios";
/**
 *
 * /Homeを踏んでからアンケートページにリダイレクト
 *
 * @param {void} - This function does not take any parameters.
 * @return {void} - This function does not return anything.
 */
export default function Home() {
  const navigate = useNavigate();
  const location = useLocation();
  const isSp = useMediaQuery(mediaQuery.sp);
  const search = useLocation().search;
  const query = new URLSearchParams(search);
  const todayKeyB64 = query.get("tod");
  const todayKey = todayKeyB64 != null ? atob(todayKeyB64) : null;
  const [serverTermsVersion, setServerTermsVersion] = useState<string>("");
  const [openDialogSt, setOpenDialogSt] = useState<boolean>(false);
  const [markdownStr, setMarkdownStr] = useState<string>("");
  const dummyImageStr = "";
  const handleDownloadImage = (imageUrl: string) => {
    // ホーム画面では画像のダウンロードは行わないため、何もしない
  };

  const handleJumpToQuestion = () => {
    // スマホ用のコンポーネントにリダイレクト
    if (isSp) {
      navigate("/questskiSp");
    } else {
      navigate("/questskiPc");
    }
  };
  const handleJumpToRegister = () => {
    navigate("/register");
  };

  const theme = createTheme({
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            backgroundColor: "#007bff",
            color: "#fff",
            fontSize: "1.0rem",
            minWidth: isSp ? "50vw" : "15vw",
            marginTop: "rem",
            "&:hover": {
              backgroundColor: "#0056b3",
            },
          },
        },
      },
    },
  });
  const openDialogForUserTerm = () => {
    setOpenDialogSt(true);
  }
  const setOpenDialog = () => {
    setOpenDialogSt(false);
    localStorage.setItem("terms-version", serverTermsVersion);
  };
  useEffect(() => {
    const downloadUserTerms = () => {
      axios
        .get("https://r0hp68v5l6.execute-api.ap-northeast-1.amazonaws.com/poc/")
        .then((response) => {
          if (response.data) {
            console.log(localStorage.getItem("terms-version"));
            const termsVersion = JSON.parse(response.data.body).version;
            setMarkdownStr(JSON.parse(response.data.body).userTerms);
            setServerTermsVersion(termsVersion);
            // ローカルストレージに利用規約のバージョン情報が存在するか確認
            // バージョン情報が一致した場合のみ利用規約のダイアログを表示しない
            if (localStorage.getItem("terms-version") === termsVersion) {
              setOpenDialogSt(false);
            } else if (localStorage.getItem("terms-version") === null) {
              setOpenDialogSt(true);
            } else if (localStorage.getItem("terms-version") !== termsVersion) {
              setOpenDialogSt(true);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };

    const setlocalStorage = () => {
      if (!location.state) {
        if (todayKey != null) {
          localStorage.setItem("today-key", todayKey);
        } else {
          localStorage.setItem("today-key", "");
        }
      }
    };
    // ローカルストレージに当日のアクセスキーを収納
    setlocalStorage();
    downloadUserTerms();
  }, [todayKey, location.state]);
  return (
    <>
      <CommonHeader />
      <div className={styles.container}>
        <h1 className={styles.title}>簡単なアンケート回答後</h1>
        <h1 className={styles.title}>画像閲覧可能になります</h1>
        <h1 className={styles.questionSubtitle}>アンケートにご協力ください</h1>
        <div className={styles.nextBtn}>
          <ThemeProvider theme={theme}>
            <Button onClick={handleJumpToQuestion}>アンケートへ</Button>
          </ThemeProvider>
        </div>
        <h3 className={styles.subtitle}>
          顔情報の事前登録が済んでいない方はコチラ
        </h3>
        <div className={styles.nextBtn}>
          <ThemeProvider theme={theme}>
            <Button onClick={handleJumpToRegister}>事前登録</Button>
          </ThemeProvider>
        </div>
        <p
          className={styles.termsLink}
          onClick={openDialogForUserTerm}>
          利用規約
        </p>
      </div>
      <BaseDialog
        open={openDialogSt}
        imageStr={dummyImageStr}
        urlStr={markdownStr}
        onCancel={() => setOpenDialog()}
        onOk={() => setOpenDialog()}
        handleDownloadImage={handleDownloadImage}
      ></BaseDialog>
    </>
  );
}
